/*eslint-disable */
define(function(require) {
    var Backbone           = require('backbone');
    var StoredPaymentModel = require('common/model/profile-stored-payment');
    var xhrUris = require('common/xhr-uris');

    return Backbone.Collection.extend({

        url  : xhrUris.customerStoredPayment,
        model: StoredPaymentModel,

        parse: function(data) {
            var storedPaymentModel = new StoredPaymentModel;
            return data && storedPaymentModel.format(data.storedPayments || []);
        }

    });
});
